"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Rocket, ClipboardCheck, GraduationCap, TrendingUp, Users, ArrowRight, CircleCheck, ExternalLink } from "lucide-react";
const services = [{
  title: "מטפל סיעודי פרטי",
  description: "השגחה צמודה וטיפול אישי בבית המטופל או בבית החולים על ידי צוות מקצועי ומסור.",
  icon: Users,
  colorClass: "text-secondary",
  bgIconClass: "bg-secondary/10",
  bgShapeClass: "bg-secondary/5",
  link: "/CaregiverServicePagesPage"
}, {
  title: "ליווי רפואי 24/7",
  description: "מענה מיידי וליווי מקצועי מסביב לשעון, כולל ניהול תרופות ומעקב רפואי שוטף.",
  icon: ClipboardCheck,
  colorClass: "text-primary",
  bgIconClass: "bg-primary/10",
  bgShapeClass: "bg-primary/5",
  link: "/NursingCareNowPage"
}, {
  title: "שיקום והחלמה",
  description: "תוכניות טיפול מותאמות אישית לאחר ניתוח או אשפוז לשיפור איכות החיים והתפקוד.",
  icon: GraduationCap,
  colorClass: "text-secondary",
  bgIconClass: "bg-secondary/10",
  bgShapeClass: "bg-secondary/5",
  link: "/CaregiverServicePagesPage2"
}, {
  title: "ייעוץ והכוונה",
  description: "סיוע במיצוי זכויות מול המוסדות השונים והתאמת פתרון הטיפול המדויק למשפחה.",
  icon: TrendingUp,
  colorClass: "text-primary",
  bgIconClass: "bg-primary/10",
  bgShapeClass: "bg-primary/5",
  link: "/ProfessionalBlogPage"
}, {
  title: "שירותי חירום",
  description: "הצבת מטפל סיעודי מיומן בביתכם תוך 5 שעות בלבד מרגע הפנייה הראשונית.",
  icon: Rocket,
  colorClass: "text-secondary",
  bgIconClass: "bg-secondary/10",
  bgShapeClass: "bg-secondary/5",
  link: "/NurseInTelAvivWithinHoursPage"
}];
export default function ServiceOfferingsGrid() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: bannerRef,
    isVisible: isBannerVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="258793" id="שירותים-סיעודיים" className="py-24 bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#8080800a_1px,transparent_1px),linear-gradient(to_bottom,#8080800a_1px,transparent_1px)] bg-[size:24px_24px] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        
        {}
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ${isHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="text-sm font-bold tracking-wider uppercase text-secondary mb-4 block">
            השירותים שלנו
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6 font-default">
            מעטפת טיפולית מקצועית בביתכם
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            אנחנו כאן כדי להעניק לכם שקט נפשי עם פתרונות סיעוד מתקדמים, זמינות מיידית ויחס אישי לכל מטופל.
          </p>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {services.map((service, i) => <Card key={i} data-index={i} className={`relative overflow-hidden border-border/40 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1 p-8 flex flex-col gap-0 group bg-card rounded-lg ${isGridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              {}
              <div className={`absolute -top-12 -right-12 w-40 h-40 rounded-lg ${service.bgShapeClass} opacity-70 transition-transform duration-500 group-hover:scale-110`} />

              <div className={`w-12 h-12 rounded-lg ${service.bgIconClass} flex items-center justify-center mb-6 relative z-10`}>
                <service.icon className={`w-6 h-6 ${service.colorClass}`} />
              </div>

              <h3 className="text-xl font-bold text-foreground mb-3 font-default relative z-10">
                {service.title}
              </h3>
              
              <p className="text-muted-foreground mb-8 flex-grow relative z-10 font-default">
                {service.description}
              </p>

              <Link to={service.link} className={`inline-flex items-center font-semibold text-sm ${service.colorClass} hover:opacity-80 transition-opacity relative z-10 w-fit`}>
                למידע נוסף <ArrowRight className="mr-2 w-4 h-4 transition-transform group-hover:-translate-x-1 rotate-180" />
              </Link>
            </Card>)}
        </div>

        {}
        <div ref={bannerRef} className={`max-w-5xl mx-auto transition-all duration-700 delay-300 ${isBannerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <Card className="bg-card/80 backdrop-blur-sm border-border/50 shadow-md p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 md:gap-12 overflow-hidden relative rounded-lg">
            {}
            <div className="absolute top-0 right-0 w-64 h-64 bg-secondary/5 rounded-lg blur-3xl -z-10 opacity-50 translate-x-1/2 -translate-y-1/2" />
            
            <div className="w-full md:w-2/5 shrink-0">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_certification.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_certification.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_certification.png-wvc-sizes" alt="הסמכה מקצועית לסיעוד" className="w-full h-auto rounded-lg shadow-sm border border-border/20" loading="lazy" />
            </div>
            
            <div className="w-full md:w-3/5 flex flex-col items-start">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-secondary/10 text-secondary text-xs font-bold tracking-wider uppercase mb-5">
                <CircleCheck className="w-4 h-4" /> ספק מורשה ומבוטח
              </div>
              
              <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-4 font-default">
                עמידה בתקני האיכות המחמירים ביותר
              </h3>
              
              <p className="text-muted-foreground mb-6 leading-relaxed font-default">
                כל המטפלים שלנו עוברים סינון קפדני, הכשרות תקופתיות ובדיקות רקע מקיפות. אנו מחויבים למתן שירות מקצועי העומד בסטנדרטים הגבוהים ביותר של משרד הבריאות והרווחה.
              </p>
              
              <Link to="/ContactPage" className="inline-flex items-center font-semibold text-secondary hover:opacity-80 transition-colors group">
                צרו קשר לייעוץ ראשוני חינם
                <ExternalLink className="mr-2 w-4 h-4 transition-transform group-hover:-translate-y-0.5 group-hover:-translate-x-0.5" />
              </Link>
            </div>
          </Card>
        </div>

      </div>
    </section>;
}